<template>
    <div class="conference">
        <section v-if="registration.conference.is_allow_invoice">
            <div class="content pb-4">
                <h4 class="mb-4">Purchase Order (P.O.) - Invoice/Request</h4>
                <hr/>
                <div class="columns">
                    <div class="column is-11 content">
                        <h3 class="mt-4"><i class="fad fa-triangle-exclamation has-text-warning mr-4"></i>Additional Action is Required...</h3>

                        <p class="mt-5">Thanks for registering. You've opted to have your registration paid by Purchase Order (P.O.). Click the button below to generate a P.O. Request (Invoice) which you must submit for a purchase order.</p>
                        <p>Please note the following:</p>
                        <ul>
                            <li>Carefully follow any instructions on the P.O. request (invoice) and follow through on this process.</li>
                            <li>Your registration will not be complete until the purchase order process is complete.</li>
                            <li>Please allow enough time before the conference for this process including up to 48 hours to process and confirm your registration.</li>
                        </ul>
                        <p>Once the purchase order process is complete you'll receive an additional email to confirm your registration.</p>

                        <p>Your registration reference code is: <strong>{{ registration.code }}</strong></p>
                        <!--                        <b-select v-model="registration.regType" expanded>-->
                        <!--                            <option v-for="type in conference.regTypes" :value="type" v-if="!type.is_hidden">{{ type.title }} ({{ type.fee | currency }})</option>-->
                        <!--                        </b-select>-->
                    </div>
                </div>
            </div>
            <hr/>
            <div class="content pt-5">
                <h6>Bill To: </h6>
                <div class="columns">
                    <div class="column">
                        <b-field label-position="inside">
                            <template #label>Organization Name <span class="required-flag">*</span></template>
                            <b-input v-model="registration.po_mail_to"></b-input>
                        </b-field>
                    </div>
                    <div class="column is-4">
                        <b-input placeholder="Attention To" v-model="registration.po_attn_to"></b-input>
                    </div>
                </div>

                <div class="columns">
                    <div class="column">
                        <b-input placeholder="Phone Number" v-model="registration.po_phone" v-mask="'(###) ###-####'"></b-input>
                    </div>
                    <div class="column">
                        <b-input placeholder="Fax Number" v-model="registration.po_fax" v-mask="'(###) ###-####'"></b-input>
                    </div>
                    <div class="column is-6">
                        <b-input type="email" placeholder="Email Address" v-model="registration.po_email"></b-input>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-9">
                        <b-input placeholder="Address" v-model="registration.po_address_1"></b-input>
                    </div>
                    <div class="column">
                        <b-input placeholder="Suite, etc." v-model="registration.po_address_2"></b-input>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-4">
                        <b-input placeholder="City" v-model="registration.po_city"></b-input>
                    </div>
                    <div class="column is-4">

                        <b-select placeholder="State" v-model="registration.po_state" expanded>
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </b-select>

                    </div>
                    <div class="column is-4">
                        <b-input placeholder="Zip" v-model="registration.po_zip" v-mask="'#####-####'"></b-input>
                    </div>
                </div>

                <b-button class="mt-4" type="is-primary" @click="save"><i class="far fa-file-invoice mr-2"></i>Save & Generate</b-button>

            </div>
        </section>

        <section v-else>
            <div class="content pb-4">
                <h4 class="mb-4">Purchase Order (P.O.)</h4>
                <hr/>
                <div class="columns">
                    <div class="column is-11 content">
                        <h3 class="mt-4"><i class="fad fa-triangle-exclamation has-text-warning mr-4"></i>Additional Action is Required...</h3>

                        <p class="mt-5">Thanks for registering. You've opted to have your registration paid by Purchase Order (P.O.).</p>
                        <p>Please note the following:</p>
                        <ul>
                            <li>Your registration will not be complete until the purchase order process is complete.</li>
                            <li>Please allow enough time before the conference for this process including up to 48 hours to process and confirm your registration.</li>
                        </ul>
                        <p>Once the purchase order process is complete you'll receive an additional email to confirm your registration. Please contact the event organizer if you have any questions.</p>

                        <p>Your registration reference code is: <strong>{{ registration.code }}</strong></p>
                    </div>
                </div>
                <hr/>

                <div class="mt-5 mb-4" v-if="registration.conference.support_email">
                    <b-button tag="a" :href="'mailto:' + registration.conference.support_email + '?subject=' + registration.conference.title + '/Purchase Order ' + registration.code"><i class="far fa-envelope mr-2"></i>Contact Organizer</b-button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {client as http} from "../../http_client";

    export default {
        components: {},
        props: ['registrationId'],
        data: function() {
            return {
                registration: {
                    conference: {}
                }
            };
        },
        methods: {
            loadRegistration: function(force) {
                http.get('app/registrations/' + this.registrationId, {force}).then(response => {
                    this.registration = response.data;
                });
            },
            save: function() {
                http.put('app/registrations/' + this.registrationId, {
                    id: this.registration.id,
                    po_mail_to: this.registration.po_mail_to,
                    po_attn_to: this.registration.po_attn_to,
                    po_phone: this.registration.po_phone,
                    po_fax: this.registration.po_fax,
                    po_email: this.registration.po_email,
                    po_address_1: this.registration.po_address_1,
                    po_address_2: this.registration.po_address_2,
                    po_city: this.registration.po_city,
                    po_state: this.registration.po_state,
                    po_zip: this.registration.po_zip
                }, {force: true}).then(response => {
                    window.open('https://app.my247ed.com/#/invoice/' + this.registrationId + '/' + this.registration.code);
                    // this.$router.push({name: 'invoice', params: {registrationId: this.registrationId, code: this.registration.code}});
                });
            }
        },
        mounted() {
            this.loadRegistration();
        }
    };
</script>

<style lang="scss" scoped>
    .conference {
        // TODO change to ui-card
        background-color: white;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.4);
        margin-top: 3rem;
        padding: 3.7rem 3.7rem 6rem;
        margin-bottom: 8rem;

        &.conf-info {
            position: relative;
            padding-top: 6rem;
            margin-top: 2rem;

        }

    }
</style>
